import banner1 from "../../../assets/images/banner-1.jpg";
import bannerMobile1 from "../../../assets/images/banner-1-mobile.jpg";
import banner2 from "../../../assets/images/banner-2.jpg";
import bannerMobile2 from "../../../assets/images/banner-2-mobile.jpg";
import processTitle from "../../../assets/images/process-title.png";
import process from "../../../assets/images/process.jpg";
import { useHomeVM } from '../viewmodels/HomeVM';
import { useEffect, useRef } from "react";
import PopularWebsiteView from "./PopularWebsiteView";
import { PopularSearchModel } from "../../websites/models/PopularSearchModel";
import PopularSearchView from "./PopularSearchView";
import PopularSearchWebsiteView from "./PopularSearchWebsiteView";
import { Utils } from "../../common/views/Utils";
import AllPopularWebsiteView from "./AllPopularWebsiteView";
import { usePopularWebsiteVM } from "../viewmodels/PopularWebsiteVM";
import { usePopularSearchVM } from "../viewmodels/PopularSearchVM";
import AllPopularSearchView from "./AllPopularSearchView";
import PhotoSlideshow from "../../common/views/PhotoSlideshow";

export default function HomeView() {
    const hasLoaded = useRef(false);
    const vm = useHomeVM();
    const websiteVM = usePopularWebsiteVM();
    const searchVM = usePopularSearchVM();

    const isMobile = window.innerWidth <= 500;

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.onLoad();

        const count = isMobile ? 10 : 20;

        websiteVM.getList(count);
        searchVM.getList(count);
    }, [vm, websiteVM, searchVM, isMobile]);

    const onSelectSearch = (search: PopularSearchModel) => {
        searchVM.setSelectedText(search);
        searchVM.setShowWebsites(true);
    }

    const onCloseSearch = () => {
        searchVM.setSelectedText(null);
        searchVM.setShowWebsites(false);
    }

    const photos = () => {
        if (isMobile) {
            return [bannerMobile1, bannerMobile2];
        }
        return [banner1, banner2];
    }

    const mainContent = () => {
        return <div>
            {/*{isMobile && <>*/}
            {/*    <img src={bannerMobile} alt="Bees Express" style={{ width: "100%" }} />*/}
            {/*</>}*/}

            {/*{!isMobile && <>*/}
            {/*    <img src={banner} alt="Bees Express" style={{ width: "100%", maxHeight: 400 }} />*/}
            {/*</>}*/}

            <div>
                <PhotoSlideshow
                    photos={photos()}
                    aspectRatio={isMobile ? 4 / 3 : 16 / 5}
                />
            </div>

            <div className="ph-10 pv-20">
                <span style={{ fontSize: "x-large" }}>Popular Websites</span>
                <div className="pt-8" style={{ float: "right" }}>
                    <a onClick={() => websiteVM.setShowAll(true)}>See All</a>
                </div>
            </div>

            <div style={{ display: "flow-root" }}>
                <PopularWebsiteView list={websiteVM.list} />
            </div>

            <div className="ph-10 pv-20">
                <span style={{ fontSize: "x-large" }}>Popular Searches</span>
                <div className="pt-8" style={{ float: "right" }}>
                    <a onClick={() => searchVM.setShowAll(true)}>See All</a>
                </div>
            </div>

            <div style={{ display: "flow-root" }}>
                <PopularSearchView list={searchVM.list} onSelect={onSelectSearch} />
            </div>

            <div style={{ display: "inline-block" }}>
                <img src={processTitle} alt="Title" style={{ width: "75%", maxWidth: 700 }} />
                <img src={process} alt="Process" style={{ width: "100%", maxWidth: 1280 }} />
            </div>
        </div>;
    }

    return <>
        {mainContent()}

        {searchVM.showWebsites && searchVM.selectedText !== null && <>
            <PopularSearchWebsiteView
                key={searchVM.selectedText.id}
                search={searchVM.selectedText}
                onClose={onCloseSearch}
            />
        </>}

        {websiteVM.showAll && <AllPopularWebsiteView onClose={() => websiteVM.setShowAll(false)} />}
        {searchVM.showAll && <AllPopularSearchView onClose={() => searchVM.setShowAll(false)} />}
    </>;
}